module.exports = __webpack_public_path__ + "static/unresolved-intro-anim-4b92759b391695d50498dd4b6a99a151.mp4";